<template>
  <div id="contenedor-main-licitacion">
    <v-container
      fluid>
      <v-card
        flat
        class="mb-4">
        <v-card-text>
          <titulo-tool-bar
            :titulo="getLicitacion.numero"
            :datos="getLicitacion">
          </titulo-tool-bar>
          <opciones-tool-bar></opciones-tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <router-view></router-view>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import LICITACION from '@/graphql/querys/administracion/licitaciones/licitacion.gql';
import TituloToolBar from './TituloToolBar.vue';
import OpcionesToolBar from './OpcionesToolBar.vue';

export default {
  name: 'MainLicitacion',
  components: {
    TituloToolBar,
    OpcionesToolBar,
  },
  data() {
    return {};
  },
  apollo: {
    licitacion: {
      query: LICITACION,
      variables() {
        return {
          id: this.$route.params.idLicitacion,
        };
      },
    },
  },
  computed: {
    getLicitacion() {
      if (!this.licitacion) return {};
      return this.licitacion;
    },
  },
};
</script>

<style lang="scss">

</style>
